import axios from 'axios'
import { getHeader, purchasingUrl } from '../config'

const state = {
  purchasingList: [],
  purchasingShowByNo: {},
  purchasingID: {
    id: null,
    purchasing_no: null,
    details: []
  },
  purchasingOrder: {
    id: null,
    purchasing_no: null,
    purchasing_date: null,
    purchasing_due_date: null,
    term_due_id: '',
    ref_no: null,
    branch_no: null,
    vendor_no: null,
    subtotal: '0',
    tax_id: null,
    tax: '0',
    discount: '0',
    total: '0',
    delivery_cost: '0',
    deliver_no: null,
    status: null,
    branch: null,
    vendor: null,
    type_id: null,
    lock: null,
    company_no: null,
    ext_no: null,
    sp_no: null,
    details: [{
      id: null,
      purchasing_no: null,
      purchasing_date: null,
      branch_no: null,
      product_no: null,
      product: null,
      description: null,
      qty: null,
      qty_done: null,
      uom_id: null,
      price: '0',
      tax_id: null,
      tax: '0',
      discount: '0',
      total: '0',
      company_no: null,
      vendor_no: null
    }]
  }
}

const mutations = {
  SET_PURCHASING_LIST (state, obj) {
    state.purchasingList = obj
  },
  SET_PURCHASING_ID (state, obj) {
    state.purchasingID = obj
  },
  SET_PURCHASING_ORDER_NO (state, obj) {
    state.purchasingOrder = obj
  },
  SET_PURCHASING_SHOW_BY_NO (state, obj) {
    state.purchasingShowByNo = obj
  }
}

const actions = {
  getPurchasingList: ({ commit }, payload) => {
    axios.get(purchasingUrl + '/list?status=' + payload.status + '&vendor=' + payload.vendor, { headers: getHeader() })
      .then(response => {
        commit('SET_PURCHASING_LIST', response.data.data)
      })
  },
  getPurchasingID: ({ commit }, payload) => {
    axios.post(purchasingUrl + '/get-purchasing-no', payload, { headers: getHeader() })
      .then(response => {
        commit('SET_PURCHASING_ID', response.data.data)
      })
  },
  getPurchasingOrderByNo: ({ commit }, payload) => {
    axios.post(purchasingUrl + '/order/get-order-no', payload, { headers: getHeader() })
      .then(response => {
        commit('SET_PURCHASING_ORDER_NO', response.data.data)
      })
  },
  getPurchasingShowByNo: ({ commit }, payload) => {
    axios.post(purchasingUrl + '/show', payload, { headers: getHeader() })
      .then(response => {
        commit('SET_PURCHASING_SHOW_BY_NO', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
